/**
 * Custom-domain SPA routing: browser URL stays unscoped (e.g. /sebas) while React Router
 * matches as if the path were /{event_slug}/sebas. Set by custom-domain-rewrite edge function.
 */

const KNOWN_APP_ROUTES = new Set([
  'landing',
  'register',
  'dashboard',
  'login',
  'signup',
  'forgot-password',
  'auth',
  's',
  'admin',
  'agent',
  'student',
  'marketing',
  'complete-registration',
  'orientacion',
  'forms',
  'presentations',
]);

export function getCustomDomainEventSlug() {
  if (typeof window === 'undefined') return null;
  const slug = window.__CUSTOM_DOMAIN_EVENT_SLUG__;
  if (slug == null || typeof slug !== 'string') return null;
  const trimmed = slug.trim();
  return trimmed || null;
}

export function toVirtualPathname(pathname, eventSlug) {
  const slug = String(eventSlug).trim();
  if (!slug) return pathname;

  const path = pathname === '' ? '/' : pathname;
  const prefix = `/${slug}`;
  const lowerPath = path.toLowerCase();
  const lowerPrefix = prefix.toLowerCase();

  if (lowerPath === lowerPrefix || lowerPath === `${lowerPrefix}/` || lowerPath.startsWith(`${lowerPrefix}/`)) {
    return path;
  }

  if (path === '/') {
    return `${prefix}/`;
  }

  const firstSegment = path.split('/').filter(Boolean)[0]?.toLowerCase();
  if (firstSegment && KNOWN_APP_ROUTES.has(firstSegment)) {
    return path;
  }

  return `${prefix}${path.startsWith('/') ? path : `/${path}`}`;
}
